export default "__VITE_ASSET__9fb7c821__"